import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UserShippingAddress } from '../../../models/shopping';

@Component({
  selector: 'app-user-shipping-address-list-item',
  imports: [MatIconModule],
  templateUrl: './user-shipping-address-list-item.html',
  styleUrl: './user-shipping-address-list-item.scss',
})
export class UserShippingAddressListItem {
  @Input({ required: true }) address!: UserShippingAddress;
}
